import AssessmentCodeRepository from './controllers/AssessmentCodeRepository'
import AssessmentStructureRepository from './controllers/AssessmentStructureRepository'
import AssessmentTypeRepository from './controllers/AssessmentTypeRepository'
import BatchRepository from './controllers/BatchRepository'
import CommentRepository from './controllers/CommentRepository'
import FileRepository from './controllers/FileRepository'
import HelperRepository from './controllers/HelperRepository'
import LmsRepository from './controllers/LmsRepository'
import MarkingTypeRepository from './controllers/MarkingTypeRepository'
import MarkRepository from './controllers/MarkRepository'
import PaperRepository from './controllers/PaperRepository'
import PaymentRepository from './controllers/PaymentRepository'
import PeriodRepository from './controllers/PeriodRepository'
import QualificationRepository from './controllers/QualificationRepository'
import ReportRepository from './controllers/ReportRepository'
import RoleRepository from './controllers/RoleRepository'
import RubricRepository from './controllers/RubricRepository'
import SubjectRepository from './controllers/SubjectRepository'
import UserRepository from './controllers/UserRepository'
import LanguageRepository from './controllers/LanguageRepository'
import UserRoleRepository from './controllers/UserRoleRepository'

const repositories = {
	assessmentCode: AssessmentCodeRepository,
	assessmentStructure: AssessmentStructureRepository,
	assessmentType: AssessmentTypeRepository,
	batch: BatchRepository,
	comment: CommentRepository,
	file: FileRepository,
	helper: HelperRepository,
	language: LanguageRepository,
	lms: LmsRepository,
	mark: MarkRepository,
	markingType: MarkingTypeRepository,
	paper: PaperRepository,
	payment: PaymentRepository,
	period: PeriodRepository,
	qualification: QualificationRepository,
	report: ReportRepository,
	role: RoleRepository,
	rubric: RubricRepository,
	subject: SubjectRepository,
	user: UserRepository,
	userRole: UserRoleRepository,
};

export const RepositoryFactory = {
	get: name => repositories[name]
};
